import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UIState {
  theme: 'light' | 'dark';
  sidebarOpen: boolean;
  voiceEnabled: boolean;
  autoSpeak: boolean;
  
  // Actions
  toggleTheme: () => void;
  setTheme: (theme: 'light' | 'dark') => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setVoiceEnabled: (enabled: boolean) => void;
  setAutoSpeak: (enabled: boolean) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      // Initial state
      theme: 'light',
      sidebarOpen: false,
      voiceEnabled: true,
      autoSpeak: false,
      
      // Actions
      toggleTheme: () =>
        set((state) => {
          const newTheme = state.theme === 'light' ? 'dark' : 'light';
          
          // Update meta theme-color
          const metaThemeColor = document.querySelector('meta[name="theme-color"]');
          if (metaThemeColor) {
            metaThemeColor.setAttribute('content', newTheme === 'dark' ? '#1f2937' : '#ffffff');
          }
          
          return { theme: newTheme };
        }),
      
      setTheme: (theme) => {
        // Update meta theme-color
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
          metaThemeColor.setAttribute('content', theme === 'dark' ? '#1f2937' : '#ffffff');
        }
        
        set({ theme });
      },
      
      toggleSidebar: () =>
        set((state) => ({ sidebarOpen: !state.sidebarOpen })),
      
      setSidebarOpen: (open) =>
        set({ sidebarOpen: open }),
      
      setVoiceEnabled: (enabled) =>
        set({ voiceEnabled: enabled }),
      
      setAutoSpeak: (enabled) =>
        set({ autoSpeak: enabled }),
    }),
    {
      name: 'ui-store',
    }
  )
);

